import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";

const Popup = ({ response, flag, handleClose }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const style = {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "70%" : "30%",
    bgcolor: "background.paper",
    boxShadow: 10,
    p: 4,
    textAlign: "center",
    borderRadius: 1,
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={flag}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={flag}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <Typography
              id="transition-modal-description"
              variant="h6"
              sx={{ mt: 2 }}
            >
              {response}
            </Typography>
            <Button
              sx={{ marginTop: "15px", width: "120px" }}
              variant="contained"
              onClick={handleClose}
            >
              ok
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default Popup;
